import { defineType } from "sanity";

import { multilingualStringPreview } from "../base/multilingualArrayString";

export default defineType({
  name: "eCommerceBenefitsContent",
  title: "ECommerce Benefits Content",
  type: "object",
  preview: {
    select: {
      title: "title"
    },
    prepare({ title }) {
      return { title: multilingualStringPreview(title) };
    }
  },
  fields: [
    {
      name: "title",
      title: "Title",
      type: "multilingualArrayString",
      validation: (Rule) => Rule.required()
    },
    {
      name: "benefits",
      title: "Benefits",
      type: "array",
      of: [{ type: "multilingualArrayString" }]
    }
  ]
});
